import { LOAD_ACTION_PROGRAM_ASSIGNED, LOADED_ACTION_PROGRAM_ASSIGNED, FAILED_ACTION_PROGRAM_ASSIGNED, CANCEL_ACTION_PROGRAM_ASSIGNED } from '../../../../constants/ActionTypes'
import {GET_CONTAB_ACTIVE_REFERENCES,GET_CONTAB_ACTIVE_ACTION,GET_DOCUMENT_INTERFACE,GET_ALL_ACTION_PROGRAM_ACCOUNT_DATA,SET_ADD_ACTION_PROGRAM_ACCOUNT_MODAL_CLOSE,SET_ADD_ACTION_PROGRAM_ACCOUNT_MODAL_OPEN
    ,SET_SEARCH_APC,FILTER_ACTION_PROGRAM_ACCOUNT,SELECT_FILTER_OPTION_ACTION_PROGRAM_ACCOUNT,TOOGLE_DRAWER_CONTAB_ACTION_PROGRAM_ACCOUNT,
    ADD_Actions_Assigned,UPDATE_Actions_Assigned,Reset_Actions_Assigned,ADD_ACTION_ACCOUNT,RESET_ACTION_ACCOUNT,OPEN_CLOSE_ACTION_PROGRAM_ACCOUNT} from '../../../../constants/ActionTypes'
const InitialState={
    AllData:[],
    Data:[],
    selectedSectionId: 2,
    drawerState: false,
    search: '',
    filterOption: 'All contacts',
    addModalVisible: false,
    contableReferencesData:[],
    contableActionData:[],
    interfaceData:[],
    assignedRequestId: 0,
    assignedLoading: false,
    assignedError: null,
    assignedOwner: null,
    ModuleInterfaceId: 0,
    ActionsAssigned:[],
    ActionAccount:[],
    CurrencyId:0,
    OpenOrCloseModalActionAccount:false,
    DocumentEmissionId:0

}

function actionProgramaAccountMaintenance(state=InitialState,action){
    switch (action.type) {
            case GET_CONTAB_ACTIVE_REFERENCES:
                return {
                    ...state,
                    contableReferencesData:action.payload
                }
            case GET_CONTAB_ACTIVE_ACTION:
                return {
                    ...state,
                    contableActionData:action.payload
                }
            case GET_DOCUMENT_INTERFACE:
                return  {
                    ...state,
                    interfaceData:action.payload
                }
            case GET_ALL_ACTION_PROGRAM_ACCOUNT_DATA:

                return {
                    ...state,
                    AllData:action.payload,
                    Data:action.payload.filter(x=>((state.selectedSectionId===1)?true:false) || (state.selectedSectionId===2 && x.active===true ) || (state.selectedSectionId===3 && x.active===false )),
                }

                case SET_ADD_ACTION_PROGRAM_ACCOUNT_MODAL_OPEN:
                    return {
                        ...state,
                        addModalVisible:action.payload
                    } 
                case SET_ADD_ACTION_PROGRAM_ACCOUNT_MODAL_CLOSE:
                    return {
                        ...state,
                        addModalVisible:action.payload
                    }
                case SET_SEARCH_APC:
                    return {
                        ...state,
                        search:action.payload
                    }

                case FILTER_ACTION_PROGRAM_ACCOUNT:

                    const DT=state.AllData.filter((row)=>`${row.documentEmissionDisplay}${row.moduleInterface}${row.contableReference}${row.originDisplay}${row.contabAction}${row.activeDisplay}${row.group}`.toLowerCase().indexOf(state.search.toLowerCase())!==-1)
                                          .filter((x)=>((state.selectedSectionId===1)?true:false) || (state.selectedSectionId===2 && x.active===true ) || (state.selectedSectionId===3 && x.active===false ))
                    return {
                        ...state,
                        Data:DT
                    }
                case SELECT_FILTER_OPTION_ACTION_PROGRAM_ACCOUNT:
                    switch (action.payload) {
                        case 1: 
                        return{
                            ...state,
                            Data:state.AllData,
                            selectedSectionId:action.payload
                        }
                        case 2:
                            return {
                                ...state,
                                Data:state.AllData.filter(row=>row.active===true)
                                ,selectedSectionId:action.payload
                            }
                        case 3: 
                            return {
                                ...state,
                                Data:state.AllData.filter(row=>row.active===false), 
                                selectedSectionId:action.payload
                            }
                        default:
                            return state
                    }
            case TOOGLE_DRAWER_CONTAB_ACTION_PROGRAM_ACCOUNT:
                return {
                    ...state,
                    drawerState:!state.drawerState
                }

            case LOAD_ACTION_PROGRAM_ASSIGNED:
                return { ...state, assignedRequestId: action.requestId, assignedOwner: action.owner,
                    assignedLoading: true, assignedError: null, ActionsAssigned: [], ActionAccount: [],
                    OpenOrCloseModalActionAccount: false, DocumentEmissionId: 0, CurrencyId: 0, ModuleInterfaceId: 0 }
            case LOADED_ACTION_PROGRAM_ASSIGNED:
                if (action.requestId !== state.assignedRequestId) return state
                return { ...state, assignedLoading: false, assignedError: null, ActionsAssigned: action.payload.data,
                    DocumentEmissionId: action.payload.DocumentEmissionId, CurrencyId: action.payload.currencyId,
                    ModuleInterfaceId: action.payload.moduleInterfaceId, OpenOrCloseModalActionAccount: action.payload.openOrClose }
            case FAILED_ACTION_PROGRAM_ASSIGNED:
                if (action.requestId !== state.assignedRequestId) return state
                return { ...state, assignedLoading: false, assignedError: action.payload, OpenOrCloseModalActionAccount: false }
            case CANCEL_ACTION_PROGRAM_ASSIGNED:
                return { ...state, assignedRequestId: state.assignedRequestId + 1, assignedOwner: null,
                    assignedLoading: false, ActionsAssigned: [], ActionAccount: [], OpenOrCloseModalActionAccount: false }
            case ADD_Actions_Assigned:
                return{
                    ...state,
                    ActionsAssigned:action.payload         
                }

            case ADD_ACTION_ACCOUNT:
                    return{
                        ...state,
                        ActionAccount: [...state.ActionAccount.filter(row => action.payload.ActionProgramCatalogAccountId > 0
                            ? row.ActionProgramCatalogAccountId !== action.payload.ActionProgramCatalogAccountId
                            : !(row.ActionProgramId === action.payload.ActionProgramId && !row.ActionProgramCatalogAccountId)), action.payload]
                    }
            case RESET_ACTION_ACCOUNT:
                    return {
                            ...state,
                            ActionAccount:[]
                        }
                    
        
                case UPDATE_Actions_Assigned:
                    let NewData=state.ActionsAssigned.map((data, index)=>(index != action.payload.index ?  data : ({
                        ...data,
                        ...action.payload.data
                      })));
                      return {
                          ...state,
                          ActionsAssigned:NewData
                }
                case Reset_Actions_Assigned:
                    return {
                        ...state,
                        ActionsAssigned:[]
                    }
                case OPEN_CLOSE_ACTION_PROGRAM_ACCOUNT:
                    return{
                        ...state,
                        assignedRequestId: state.assignedRequestId + 1,
                        assignedLoading: false,
                        ActionAccount: [],
                        CurrencyId:action.payload.currencyId ?? state.CurrencyId,
                        OpenOrCloseModalActionAccount:action.payload.openOrClose === true,
                        DocumentEmissionId:action.payload.DocumentEmissionId ?? state.DocumentEmissionId
                    }
        default:
            return state
    }
}

export default actionProgramaAccountMaintenance;